import React, { useState } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setStartDate, setEndDate, setSearchTerm } from 'redux/briefing/archiveSearchSlice';

const ControlPanel = () => {
    const dispatch = useDispatch();
    const startDateRedux = useSelector((state) => state.archiveSearch.startDate);
    const endDateRedux = useSelector((state) => state.archiveSearch.endDate);
    const searchTermRedux = useSelector((state) => state.archiveSearch.searchTerm);

    const [startDate, setStartDateState] = useState(startDateRedux);
    const [endDate, setEndDateState] = useState(endDateRedux);
    const [searchTerm, setSearchTermState] = useState(searchTermRedux);

    const handleSearch = () => {
        dispatch(setStartDate(startDate));
        dispatch(setEndDate(endDate));
        dispatch(setSearchTerm(searchTerm));
    };

    return (
        <div className="control-panel">
            <Row>
                <Col md={12}>
                    <Form.Group controlId="searchTerm">
                        <Form.Label>Search</Form.Label>
                        <Form.Control
                            className='input'
                            type="text"
                            placeholder="Enter search term"
                            value={searchTerm}
                            onChange={(e) => setSearchTermState(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <br />
            <Row>
                <Col md={6}>
                    <Form.Group controlId="startDate">
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                            className='input'
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDateState(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={5}>
                    <Form.Group controlId="endDate">
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                            className='input'
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDateState(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col md={1}>
                    <div className='briefing-archive-search'>
                        <button
                            className='action-btn'
                            onClick={handleSearch}
                            title="Search"
                        >
                            <i className='fa fa-search'></i>
                        </button>
                    </div>
                </Col>
            </Row>
            <br />
        </div>
    );
};

export default ControlPanel;
